var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { getNullLogger } from "@uniformdev/common";
var getPersonalizedProps = function getPersonalizedProps(data, logger) {
  logger.debug("getPersonalizedProps - Getting personalized props from data.", {
    data: data
  });
  if (!logger) logger = getNullLogger();
  if (!data) {
    logger.debug('getPersonalizedProps - No data was specified, so unable to retrieve personalized props for component.', {
      data: data
    });
    return {};
  }
  var personalization = data.personalization,
    rest = __rest(data, ["personalization"]);
  if (personalization) {
    logger.debug('getPersonalizedProps - Personalization activity is available in the data. This activity was removed because it will be handled later.', {
      before: data,
      after: rest
    });
  }
  return {
    props: rest
  };
};
export default getPersonalizedProps;